import React, { Component, ReactNode } from "react";
import { type LucideIcon } from "lucide-react";
import PageTransition from "./PageTransition";
import PageTitle from "../../Layout/AppMain/PageTitle";

interface PageLayoutProps {
    heading?: string;
    icon?: LucideIcon;
    subheading?: string;
    /** Optional right-side content for the page title (filters, actions, etc.) */
    actions?: ReactNode;
    children: ReactNode;
    className?: string;
    noTitle?: boolean;
}

export default class PageLayout extends Component<PageLayoutProps> {
    render() {
        const { heading, icon, subheading, actions, children, className, noTitle } = this.props;
        return (
            <PageTransition>
                <div className={className}>
                    {!noTitle && heading && icon && (
                        <PageTitle heading={heading} icon={icon} subheading={subheading} actions={actions} />
                    )}
                    {children}
                </div>
            </PageTransition>
        );
    }
}
